import React from "react";
import "./Dpu_Learn_Ai_Tool_Swiper.css";

const Dpu_Learn_Ai_Tool_Swiper = () => {
  const data = [
    "/assets/images/dpu_mca/ai_tools/1.webp",
    "/assets/images/dpu_mca/ai_tools/2.webp",
    "/assets/images/dpu_mca/ai_tools/3.webp",
    "/assets/images/dpu_mca/ai_tools/4.webp",
    "/assets/images/dpu_mca/ai_tools/6.webp",
    "/assets/images/dpu_mca/ai_tools/7.webp",
    "/assets/images/dpu_mca/ai_tools/8.webp",
    "/assets/images/dpu_mca/ai_tools/9.webp",
    "/assets/images/dpu_mca/ai_tools/10.webp",
    "/assets/images/dpu_mca/ai_tools/11.webp",
    "/assets/images/dpu_mca/ai_tools/13.webp",
    "/assets/images/dpu_mca/ai_tools/14.webp",
    "/assets/images/dpu_mca/ai_tools/15.webp",
    "/assets/images/dpu_mca/ai_tools/16.webp",
  ];

  return (
    <section className="Dpu_Learn_Ai_Tool_Swiper">
      <div className="container">
        {/* Heading */}
        <div className="text_heading_div text-center">
          <span className="section_tag">OUR NETWORK</span>

          <h2 className="heading">
            Our Associates <span>/ Recruiters</span>
          </h2>

          <p className="descn_text">
            Connect with leading organizations and industry partners creating
            exciting career opportunities for our students.
          </p>
        </div>

        {/* Logo Grid */}
        <div className="new_swiper_holder">
          <div className="new_brands_holder">
            {data.map((item, index) => (
              <div className="logo-div" key={index}>
                <div className="logo-inner">
                  <img
                    src={item}
                    alt={`Associate / Recruiter ${index + 1}`}
                    className="uni-img"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dpu_Learn_Ai_Tool_Swiper;